import { styled } from '@mui/material'

/**
 * Shared bordered container used by the power price variant forms so they render consistently
 */
export const PowerPriceContainer = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.grey.grey06,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
}))
